import React, {memo, useState, useEffect} from 'react';
import { connect } from "react-redux";
import {convertSecondsToSpace} from './convertSecondsToSpace.js';
import { Group, Stage, Layer, Rect, Line} from 'react-konva';

export const LoopPoints = memo(({
    sampler,
    height,
    instrument,
    buffer,
    color,
    width,
    step,
    zoomedStartTime,
    setDraggingStart,
    setDraggingEnd
    }) => {
        if (buffer === undefined) {
            return (
                <Layer>
                </Layer>
            );
        }
        let {loopStart, loopEnd} = sampler.getLoopPoints(instrument.getLoopPoints(0, sampler));
        loopStart = convertSecondsToSpace(loopStart - zoomedStartTime, buffer, width);
        loopEnd = convertSecondsToSpace(loopEnd - zoomedStartTime, buffer, width);
        
        return (
            <Layer>
              <Rect x={loopStart} y={0} width={loopEnd - loopStart} height={height} fill={color} opacity={0.15}/>
              <Line points={[loopStart, 0, loopStart, height]} stroke="red" strokeWidth={2}/>
              <Line
                onMouseDown={setDraggingStart}
                points={[loopStart, 0, loopStart, height]}
            stroke="black"
            opacity={0}
            strokeWidth={20}/>
          <Line points={[loopEnd, 0, loopEnd, height]} stroke="red" strokeWidth={2}/>
          <Line
            onMouseDown={setDraggingEnd}
            points={[loopEnd, 0, loopEnd, height]} stroke="black" opacity={0} strokeWidth={20}/>
        </Layer>
    );
});

const mapStateToProps = (state, props) => {
    let id = state.sequencer.sequencerEngine === undefined ?
        undefined : state.sequencer.sequencerEngine.getSequenceId();
    let isPlaying = id === undefined ? false : state.sequencer.isPlaying[id] || 0;
    return {
        step: isPlaying ? state.sequencer.sequencerEngine.trackStep : 0,
        loopStart: props.instrument.loopStart,
        loopLength: props.instrument.loopLength
    };
};
 
export default connect(mapStateToProps, null)(LoopPoints);
